<template>
  <div :class="classList">
    <label v-if="label" class="display-flex"
      >{{ label.trim().replace(/\*$/, "") }}
      <span v-if="isRequired" class="asterisk-mark">*</span>

      <slot name="inside-label" />
    </label>
    <div
      v-if="adminDescription && $store.getters.isAgent"
      class="admin-description"
    >
      <div v-html="adminDescription"></div>
    </div>
    <div v-if="description" class="description">
      <div v-html="description"></div>
    </div>
    <div class="position-relative input-container">
      <textarea
        :rows="rows"
        class="form-control"
        spellcheck="true"
        :maxlength="maxLength"
        :placeholder="placeholder"
        v-model="inputVal"
        :disabled="isDisabled"
      ></textarea>
      <SpeechInput
        class="speech-input"
        :field="builderField"
        @input="handleSpeechInput($event)"
      />
    </div>
    <small
      class="float-right mr-2"
      v-if="isCounter && inputVal && inputVal.length"
    >
      {{ inputVal.length }}
      <span v-if="inputVal.length == 1"> character </span>
      <span v-else> characters </span>
    </small>
    <p class="required-message" v-if="!inputVal && submitClicked && isRequired">
      {{ getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED") }}
    </p>
  </div>
</template>
<script>
import SpeechInput from "../speech/SpeechInput.vue";

/* This component includes a label, and a textarea
Any error of textarea (for example: required field, invalid character, exceed length ...) is showed in this component */
export default {
  name: "TextAreaWithLabel",
  components: {
    SpeechInput,
  },
  props: {
    /* Name of the textarea component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12",
    },
    // Input value, which is used for v-model
    value: String,
    // Number of rows of textarea
    rows: {
      type: Number,
      default: 4,
    },
    // Max length of input
    maxLength: {
      type: Number,
    },
    placeholder: String,
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isCounter: {
      type: Boolean,
      default: false,
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false,
    },
    // Initial value
    defaultValue: String,
    builderField: Object,
    showTemplateLoader: {
      type: Boolean,
      default: false,
    },
    templateType: {
      type: String,
      default: null,
    },
    templateSelector: {
      type: String,
      default: null,
    },
  },
  created() {
    if (this.defaultValue && !this.value) {
      this.$emit("input", this.defaultValue);
    }
  },
  // created() {
  //   this.$emit("input", this.label);
  // },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    handleSpeechInput(inputText) {
      this.inputVal = inputText;
    },
  },
};
</script>

<style scoped>
.speech-input {
  position: absolute;
  right: 0;
  bottom: 0.3em;
}
</style>



// WEBPACK FOOTER //
// src/components/common/form-elements/TextAreaWithLabel.vue